import axios from 'axios'
import { clone, objectSnakeToCamelCase, getDefaultStrDate } from '@/util/libUtil.js'
import defaultCoverageForm from '@/util/defaultCoverageForm'


const state = () => ({
	coverage: {
		form: clone(defaultCoverageForm),
		isOpenCoverage: false,
		isLoadingCoverage: false,
		coverageData: [],
		coverageDataAddress: [],
		coverageDataResult: [],
	},
	paths: {
		coverageAuthPath: '/api/scraping/yoigo/cliente/cobertura/auth',
		coveragePath: '/api/scraping/yoigo/cliente/cobertura/',
		coverageAddressPath: '/api/scraping/yoigo/cliente/cobertura/direccion',
		converageResultPath: '/api/scraping/yoigo/cliente/cobertura/resultado'
	}
})

const mutations = {
	coverageForm(state, val) {
		state.coverage.coverageForm = clone(val)
	},
	coverageData(state, val) {
		state.coverage.coverageData = val
	},
	coverageDataAddress(state, val) {
		state.coverage.coverageDataAddress = val
	},
	coverageDataResult(state, val) {
		state.coverage.coverageDataResult = val
	},
	isOpenCoverage: (state, val) => {
		state.coverage.isOpenCoverage = val
	},
	isLoadingCoverage: (state, val) => {
		state.coverage.isLoadingCoverage = val
	},
	resetCoverageData: (state) => {
		state.coverage.coverageData = [];
		state.coverage.coverageDataAddress = [];
		state.coverage.coverageDataResult = [];
	}
}

const actions = {
	async authCoverage({ dispatch, getters, state, commit }) {
		try {
			await axios.get(getters.getEndpointFromPath(state.paths.coverageAuthPath))
		} catch (error) {
			console.log(error)
		}
	},
	async consultCoverage({ dispatch, getters, state, commit }, form) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.coveragePath), {
				params: form
			})
			commit('coverageData', res.data)
		} catch (error) {
			console.log(error)
		}
	},
	async consultCoverageAddress({ dispatch, getters, state, commit }, form) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.coverageAddressPath), {
				params: form
			})
			commit('coverageDataAddress', res.data)
		} catch (error) {
			console.log(error)
		}
	},
	async consultCoverageResult({ dispatch, getters, state, commit }, form) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.converageResultPath), {
				params: form
			})
			commit('coverageDataResult', res.data)
		} catch (error) {
			console.log(error)
		}
	},
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}